export default "__VITE_ASSET__BSsWu0yk__"